import { useCallback, useEffect, useState } from "react";
import { _MassMail, _MassMailItem, _single } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { BasicTable, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { PrintJson } from "../../theme/Component/PrintJson";
import { ListMenu } from "../../theme/Component/ListMenu";
import useModal, { MODAL_LG, MODAL_md, MODAL_XL } from "../../theme/Component/hooks/useModal";
import { Modal } from "../../theme/Component/Modal";
import { FileInput } from "../../theme/Component/FileInput";
import { BasicButton } from "../../theme/Component/BasicButton";
import { ImportXLSX } from "../../theme/Component/ImportXLSX";
import { toast } from "react-toastify";
import { DocumentPDF, DocumentViewer } from "../../theme/Component/DocumentViewer";
import { VisorAnyDocument } from "../../documents/VisorAnyDocument";

interface Props {
    massEmail: any;
}
export const MassEmailItem = ({ massEmail }: Props) => {

    const _massEmailItem = useDataBean(_MassMailItem);

    const _massEmail = useDataBean(_MassMail);
    const { lista, getLista, bean, setBean, instance, handleChange, getListaLike } = _massEmailItem;
    const modalItems = useModal("Items", MODAL_LG);
    const [dest, setDest] = useState<any>([]);
    const [subject, setSubject] = useState<string>('');
    const modalView = useModal("Vista", MODAL_XL);
    const modalEditar = useModal("Editar", MODAL_md);
    const [docs, setDocs] = useState<any>([]);

    useEffect(() => {
        getListaItems();
    }, [massEmail])

    const getListaItems = useCallback(() => {
        if (massEmail.IDMassMail) {
            getLista({ IDMassMail: massEmail.IDMassMail }, null);
        }
    }, [])

    const viewDocument = () => {
        let temp: any = [];
        let doc = {
            Filename: bean.FileName,
            MediaContext: "",
            Media: "",
            Type: "pdf",
            URLLink: bean.URLLink
        }
        setDocs([doc]);
        modalView.open();
    }

    const updateItem = () => {

        instance.updateCustonBean(bean).then(
            (resp: any) => {
                getListaItems();
                modalEditar.close();
            }
        )
    }



    const head = [
        { title: 'ID', property: 'MassMailItem', visible: true, mask: MASK_NUMBER },
        { title: 'Funcionario', property: 'NameAccount', visible: true },
        { title: 'Destinatario', property: 'EmailAccount', visible: true },
        { title: 'URL', property: 'URLLink', visible: false },
        { title: 'Adjunto', property: 'FileName', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { setBean({}); modalItems.open(); } }
    ]
    const listaBotones = () => {
        const botones = [
            // {titulo:'Ver items',icono:'ri-file-list-line',visible:true,evento:() => {modalItems.open() }},            
            { titulo: 'Ver', icono: 'ri-file-pdf-line', visible: true, evento: viewDocument },
            { titulo: 'Enviar', icono: 'ri-mail-send-line', visible: true, evento: enviarMail },
            { titulo: 'Editar', icono: 'ri-edit-line', visible: true, evento: () => { modalEditar.open() } },
            { titulo: 'Eliminar', icono: 'ri-eraser-fill', visible: true, evento: () => { _massEmailItem.deleteItem(bean.IDMassMailItem) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const enviarMail = () => {
        _massEmail.instance.sendMassMailItem(massEmail.IDMassMail, bean.MassMailItem, bean.NameAccount).then(
            (resp: any) => {
                toast.success("Mensaje enviado");
            }
        )
    }
    const enviarAllMail = () => {
        if (subject != '') {
            _massEmail.instance.sendMassMail(massEmail.IDMassMail, subject).then(
                (resp: any) => {
                    toast.success("Mensaje enviado");
                }
            )
        } else {
            toast.warning("Falta el asunto del mensaje");
        }
    }

    const cargarDatos = () => {
        _massEmail.instance.uploadDestinatario(massEmail.IDMassMail, JSON.stringify(dest), JSON.stringify(bean.attach)).then(
            (resp: any) => {
                console.log(resp);
                getLista({ IDMassMail: massEmail.IDMassMail }, null);
            }
        )
    }

    return (
        <div className="row">
            <div className="col-md-8">
                <label>Asunto</label>
                <input type="text" className="form-control" onChange={(e) => { setSubject(e.target.value) }} />
            </div>
            <div className="col-md-3 mt-4">
                <BasicButton disable={lista.length == 0} icon="ri-mail-send-fill" eventClick={enviarAllMail} >Enviar Todos</BasicButton>
            </div>
            <div className="col-md-12">
                <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} head={head} body={lista} rowSet={setBean}></BasicTable>
                <Modal modal={modalItems.modal} updateModal={modalItems.setModal} eventModal={cargarDatos}>
                    <div className="row">
                        <div className="col-md-12">
                            <h5>Cargar Destinatarios</h5>
                            <ImportXLSX label="Archivo destinatarios" lodaData={setDest} />
                            <p>
                                El archivo debe contener las siguientes columnas sin titulos: <br />
                                columna A = nombre del archivo <small>Sin extension </small> <br />
                                columna B = correo <br />
                                columna C = Nombre Destinatario <br />
                            </p>
                            {/* <br />
                            <BasicButton icon="" eventClick={destinatario}>Subir</BasicButton> */}
                        </div>
                        <div className="col-md-12 mt-4">
                            <hr />
                            <h5>Cargar Archivos</h5>
                            <FileInput label="Archivo Adjuntos" directory="massemail" onCreate={(e) => { setBean({ ...bean, "attach": e }) }} />
                            <p>
                                Archivo zip en su interior todos los documentos a enviar *.pdf
                            </p>
                            {/* <br />
                            <BasicButton icon="" eventClick={subirArchivos}>Subir</BasicButton> */}
                        </div>
                    </div>
                </Modal>
                <Modal modal={modalView.modal} updateModal={modalView.setModal}>
                    {/* <DocumentViewer list={docs}/> */}
                    <VisorAnyDocument url={bean?.URLLink} type={'pdf'} />
                </Modal>
                <Modal modal={modalEditar.modal} updateModal={modalEditar.setModal} eventModal={updateItem} onSubmitLabel="Editar">
                    <div className="row">
                        <div className="col-md-12">
                            <input className="form-control" type="text" name="EmailAccount" id="EmailAccount" value={bean.EmailAccount} onChange={handleChange} />
                        </div>
                    </div>

                </Modal>
                {/* <PrintJson json={massEmail} /> */}
            </div>
        </div>
    )
}